import { IdentityProvider } from '@prisma/client';

export const IDENTITY_PROVIDERS = IdentityProvider;

export * from '@prisma/client';
